import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Nosotros from '@/components/Nosotros'
import Contacto from '@/components/Contacto'
import fiscal from '@/components/fiscal'
import contraloria from '@/components/contraloria'
import gob from '@/components/gob'
import legal from '@/components/legal'
import logistica from '@/components/logistica'
import marketing from '@/components/marketing'
import outsourcing from '@/components/outsourcing'
import rh from '@/components/rh'
import formulario from '@/components/formulario'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/nosotros',
      name: 'Nosotros',
      component: Nosotros
    },
    {
      path: '/contacto',
      name: 'Contacto',
      component: Contacto
    },
    {
      path: '/fiscal',
      name: 'Fiscal',
      component: fiscal
    },
    {
      path: '/legal',
      name: 'legal',
      component: legal
    },
    {
      path: '/logistica',
      name: 'logistica',
      component: logistica
    },
    {
      path: '/marketing',
      name: 'marketing',
      component: marketing
    },
    {
      path: '/outsourcing',
      name: 'outsourcing',
      component: outsourcing
    },
    {
      path: '/gob',
      name: 'gob',
      component: gob
    },
    {
      path: '/contraloria',
      name: 'contraloria',
      component: contraloria
    },
    {
      path: '/rh',
      name: 'rh',
      component: rh
    },
    {
      path: '/formulario',
      name: 'formulario',
      component: formulario
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js